import React from 'react'
import styles from './Pallets.module.css'

// The speech bubble for pallet notes (186; Adrian and Vanessa, 2026-11-02):
// on a pallet it carries that pallet's note, on a stock line every note on
// its live pallets. The text is in the title and the accessible name, so a
// hover or a screen reader gives it without opening anything.

export interface NoteLine {
  pallet_id?: string
  text: string
}

export function NoteBubble({ notes }: { notes: NoteLine[] }) {
  if (!notes.length) return null
  const text = notes.map((n) => (n.pallet_id ? `${n.pallet_id}: ${n.text}` : n.text)).join('\n')
  return (
    <span className={styles.noteBubble} title={text} aria-label={`Note${notes.length === 1 ? '' : 's'}: ${text}`} role="img" data-testid="note-bubble">
      <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden>
        <path d="M2.5 2.5h11a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H7l-3 2.5V11H2.5a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1z" fill="currentColor" />
      </svg>
      {notes.length > 1 && <span className={styles.noteCount}>{notes.length}</span>}
    </span>
  )
}
